import { useTranslation } from 'react-i18next'
import { i18n } from '@fs/zion-locale'
import { useFeatureFlag } from '@fs/zion-flags'
import isCoreLanguage from './isCoreLanguage'

export default function useActivitiesLinks() {
  const { t } = useTranslation()
  const { isOn: showChinesePhotoCollage } = useFeatureFlag('home_header_zhPhotoCollage')
  const { isOn: showChineseTreeDesigns } = useFeatureFlag('home_header_zhTreeDesigns')
  const { isOn: showActivitiesTogetherLink } = useFeatureFlag('home_header_activitiesTogetherLinkChange')

  let surnamePath = `/${i18n.language}/surname`

  if (['zh', 'zh-hans'].includes(i18n.language)) {
    surnamePath = '/chinese/surnames'
  }

  const activitiesLinks = {
    id: 'activities',
    text: t('nav.activities', 'Activities'),
    sub: [
      { id: 'all_activities', text: t('nav.activities.all-activities', 'All Activities'), url: '/discovery/' },
      { id: 'together_app', text: t('nav.activities.together-app', 'Together App'), url: '/discovery/together' },
      {
        id: 'where_am_i_from',
        text: t('nav.activities.where-am-i-from', 'Where Am I From?'),
        url: '/discovery/explore/',
      },
      {
        id: 'surname-origins',
        text: t('nav.activities.surname-origins', 'Surname Origins'),
        url: surnamePath,
      },
      { id: 'all_about_me', text: t('nav.activities.all-about-me', 'All About Me'), url: '/discovery/about' },
      {
        id: 'famous_relatives',
        text: t('nav.activities.famous-relatives', 'Famous Relatives'),
        url: '/discovery/famousrelatives',
      },
      {
        id: 'compare_a_face',
        text: t('nav.activities.compare-a-face', 'Compare-a-Face'),
        url: '/discovery/compare',
      },
      {
        id: 'record_my_story',
        text: t('nav.activities.record-my-story', 'Record My Story'),
        url: '/discovery/record',
      },
      {
        id: 'picture_my_heritage',
        text: t('nav.activities.picture-my-heritage', 'Picture My Heritage'),
        url: '/discovery/picture',
      },
      {
        id: 'in_home_activities',
        text: t('nav.activities.in-home-activities', 'In-Home Activities'),
        url: '/discovery/activities/',
      },
      {
        id: 'chinese_tree_designs',
        text: '家庭樹設計',
        url: '/zh/tree-designs/chinese/',
      },
      {
        id: 'photo_collage',
        text: '相片拼貼畫設計器',
        url: '/campaign/photocollage',
      },
    ],
  }

  activitiesLinks.sub = activitiesLinks.sub.filter((link) => {
    if (
      [
        'all_activities',
        'where_am_i_from',
        'all_about_me',
        'famous_relatives',
        'compare_a_face',
        'record_my_story',
        'picture_my_heritage',
        'in_home_activities',
      ].includes(link.id) &&
      !isCoreLanguage(i18n.language)
    ) {
      return false
    }

    if (link.id === 'chinese_tree_designs' && !(i18n.language === 'zh' && showChineseTreeDesigns)) {
      return false
    }

    if (link.id === 'photo_collage' && !(i18n.language === 'zh' && showChinesePhotoCollage)) {
      return false
    }

    if (link.id === 'together_app') {
      return (
        showActivitiesTogetherLink &&
        [
          'hy',
          'en',
          'pt',
          'fr',
          'ht',
          'it',
          'de',
          'es',
          'ru',
          'zh',
          'ja',
          'ko',
          'th',
          'da',
          'hu',
          'nl',
          'pl',
          'sv',
          'sk',
          'fi',
          'bg',
          'ro',
          'sm',
          'to',
          'km',
          'id',
          'vi',
          'fj',
          'sq',
          'cs',
          'no',
          'mn',
          'uk',
          'tl',
          'ceb',
          'et',
          'mg',
          'lv',
          'lt',
          'hr',
          'ms',
          'ka',
          'tr',
          'ar',
          'fa',
        ].includes(i18n.language)
      )
    }

    if (link.id === 'in_home_activities' && showActivitiesTogetherLink) {
      return false
    }

    return true
  })

  return activitiesLinks
}
